import { handleActions } from 'redux-actions';
import { createLoadListReducerWithBegin } from '../../utils/getCrudConfig';
import { CAMERA_MODULE } from '../../configs/moduleNames';
import { LOAD_CAMERAS_LIST, LOAD_CAMERAS_STATUSES_LIST, SET_SERVER_TIME_ZONE } from './actions';
import ListType from '../../dto/converters/ListType';
import CameraDTO from '../../dto/CameraDTO';
import HostStatusDTO from '../../dto/HostStatusDTO';

const initialState = {
  loadingCamerasList: false,
  camerasList: [],
  camerasListMeta: {},
  loadingCamerasStatusesList: false,
  camerasStatusesList: [],
  camerasStatusesListMeta: {},
  serverTimezone: 'Europe/Moscow',
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(CAMERA_MODULE + LOAD_CAMERAS_LIST, 'camerasList', 'loadingCamerasList'),
  ...createLoadListReducerWithBegin(CAMERA_MODULE + LOAD_CAMERAS_STATUSES_LIST, 'camerasStatusesList', 'loadingCamerasStatusesList'),
  ...createLoadListReducerWithBegin(CAMERA_MODULE + SET_SERVER_TIME_ZONE, 'serverTimezone', 'loadingServerTimezone', 'Europe/Moscow'),
}, initialState);

export default reducer;

export const getCamerasData = state => {
  const reducerData = state[CAMERA_MODULE];
  const {
    loadingCamerasList = false,
    camerasList = [],
    camerasListMeta = {},
    loadingCamerasStatusesList = false,
    camerasStatusesList: statusesList = [],
    camerasStatusesListMeta = {},
    serverTimezone = '',
  } = reducerData;
  const cList = new ListType(CameraDTO)(camerasList);
  const camerasStatusesList = new ListType(HostStatusDTO)(statusesList);
  return {
    loadingCamerasList,
    camerasList: cList,
    camerasListMeta,
    loadingCamerasStatusesList,
    camerasStatusesList,
    camerasStatusesListMeta,
    serverTimezone,
  };
};
